import React, { useEffect, useState } from 'react';
import { Col, Row, Container } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import GroupOptions from 'shared/components/GroupOptions';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from 'shared/components/Buttons';
import MainSpinner from 'shared/components/MainSpinner';
import PropTypes from 'prop-types';
import useApi from 'hooks/useApi';
import { selectCurrentClient } from 'redux/actions/clientActions';
import AlertModal from 'shared/components/AlertModal';

const CommunicationClients = ({ getDocumentById }) => {
  const { customAreaApi } = useApi();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const theme = useSelector((state) => state.theme);
  const [selectedOption, setSelectedOption] = useState();
  const [clientsAndContacts, setClientsAndContacts] = useState([]);
  const [options, setOptions] = useState([]);
  const [selectedClient, setSelectedClient] = useState();
  const [isErrorOpen, setIsErrorOpen] = useState(false);
  const { currentNotificationReview } = useSelector((state) => state.notificationReview);
  const { cusNavId } = useSelector((state) => state.auth);

  const [{ loading: getClientLoading }, getClient] = customAreaApi(
    {
      method: 'GET',
    },
    { manual: true }
  );

  const setClientData = async (clientId) => {
    const {
      data: { data },
    } = await getClient({
      url: `${window.API_V1}/cli/clients/${cusNavId}/${clientId}`,
    });
    dispatch(selectCurrentClient(data));
  };

  const { mainColor } = theme;

  useEffect(() => {
    setOptions(
      currentNotificationReview?.clientsAndContacts?.map((client) => ({
        name: client.clientName,
        value: client.clientId,
      })) || []
    );
    setClientsAndContacts(currentNotificationReview?.clientsAndContacts || undefined);
  }, [currentNotificationReview]);

  useEffect(() => {
    setSelectedClient(
      clientsAndContacts?.find((client) => client.clientId === selectedOption) || undefined
    );
  }, [selectedOption]);

  const onClickOption = async (value) => {
    setSelectedOption(value);
  };

  const getDocumentByIdHandler = async () => {
    await setClientData(selectedOption);
    if (!selectedClient.idFolderFileManager) {
      setIsErrorOpen(true);
    } else {
      getDocumentById(selectedClient.idFolderFileManager, selectedClient.clientId);
    }
  };

  const onToggleError = () => setIsErrorOpen((isOpen) => !isOpen);

  return (
    <div>
      <Row className="row-title">
        <Col sm={12}>
          <h3>{t('notification_clients_modal_title')}</h3>
        </Col>
      </Row>
      <GroupOptions
        className="general-customizer__page-header-otions"
        color={mainColor}
        options={options}
        onClick={onClickOption}
        selectedOption={selectedOption}
        showContainerIcon={false}
      />

      <Container className="py-3 px-0">
        <Row>
          <Col xs={12} className="flex flex-row justify-content-end">
            <Button
              className="home__btn text-uppercase"
              type="button"
              label={t('notification_clients_modal_button')}
              color="primary"
              onClick={getDocumentByIdHandler}
              disabled={!selectedClient || getClientLoading}
            />
          </Col>
        </Row>
      </Container>

      {getClientLoading && <MainSpinner />}

      <AlertModal
        type="error"
        isOpen={isErrorOpen}
        toggle={onToggleError}
        message={t('notification_clients_modal_error')}
        okText={t('general_button_ok')}
        onOk={onToggleError}
      />
    </div>
  );
};

CommunicationClients.propTypes = {
  getDocumentById: PropTypes.func.isRequired,
};

export default CommunicationClients;
